<vp-link [editableInStoryblok]="_editable" [link]="anchorLink" type="button">
	{{ text }}
</vp-link>
